// extracted by mini-css-extract-plugin
module.exports = {"accordion":"styles_accordion__mw_Tg","contentWrapper":"styles_contentWrapper__jJFZf","content":"styles_content__4QEOk"};